import Storage from './Storage';

const MARK = 'home-page-address';

class HomePageAddress {
  set(url) {
    const __url = this.get();

    if (__url != null) {
      return;
    }

    Storage.set(MARK, url);
  }

  get() {
    return Storage.get(MARK);
  }
}

export default new HomePageAddress(); 